import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { MainFilterHandler } from "../../../../components/comman/MainFilterHandler";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import { callApi } from "../../../../ApiHelper/ApiHelper";
import EditIcon from "../../../../components/Icons/EditIcon";
import MainHeading from "../../../../components/comman/MainHeading";
import FilterComponent from "../../../../components/comman/FilterComponent";
import CommonTable from "../../../../components/comman/CommonTable";
import { useSelector } from "react-redux";
import PlusIcon from "../../../../components/Icons/PlusIcon";
import { RoutesLink } from "../../../../ApiHelper/RoutesLink";


export default function OfficeSalaryHead() {
  const navigate = useNavigate();
  const location = useLocation();
  const timeoutId = useRef(null);
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    OfficeSalaryHeadData: [],
    searchQuery: "",
  });

  useEffect(() => {
    GetOfficeSalaryHead();
  }, [
    pageStates?.searchQuery,
    pageStates?.currentPage,
    pageStates.pageSize,
    location?.state?.data?.type,
    filterDetails?.orderBy,
  ]);

  const GetOfficeSalaryHead = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_office_salary_head +
      `?` +
      MainFilterHandler({ ...pageStates, orderBy: filterDetails?.orderBy }) +
      `&type=${location?.state?.data?.type || "office"}`;
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.officeSalaryHead?.map((item) => ({
          ...item,
          companyName: item?.Company?.name,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          OfficeSalaryHeadData: newData,
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.add_office_salary_head, { state: { data: data } });
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "name", label: "Office Name" },
    { value: "companyName", label: "Company" },
  ];

  const ActionData = [
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      clickHandler: HandleUpdate,
    },
  ];

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 500);
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <MainHeading
        title={"Office Salary Head"}
        buttonText={"Add"}
        buttonIcon={<PlusIcon />}
        buttonLink={RoutesLink?.add_office_salary_head}
        state={{ OfficeSalaryHeadData: pageStates?.OfficeSalaryHeadData }}
      />
      <div className="card mb-4">
        <div className="card-body">
          <FilterComponent
            handleSearch={handleSearchChange}
            searchPlaceHolder={"Search By Office Name"}
            orderByHandler={orderByHandler}
            orderByList={orderByList}
          />
          <CommonTable
            TableHeading={TableHeading}
            TableData={pageStates?.OfficeSalaryHeadData}
            ActionData={ActionData}
            currentPage={pageStates?.currentPage}
            PageChangeHandler={PageChangeHandler}
            isLoading={pageStates?.tableLoader}
            totalPages={pageStates?.totalPages}
            count={pageStates?.count}
            handleChangePageSize={handleChangePageSize}
            pageSize={pageStates.pageSize}
          />
        </div>
      </div>
    </>
  );
}
